import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const SERVICE_LINKS = [
  { to: "/services", label: "Graphic Design" },
  { to: "/services", label: "Branding" },
  { to: "/services", label: "Image Editing" },
  { to: "/services", label: "Video Editing" },
  { to: "/services", label: "Creator Content" },
];

const STUDIO_LINKS = [
  { to: "/portfolio", label: "Portfolio" },
  { to: "/subscriptions", label: "Subscriptions" },
  { to: "/pricing", label: "Get a Quote" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

const LEGAL_LINKS = [
  { to: "/legal/terms", label: "Terms" },
  { to: "/legal/privacy", label: "Privacy" },
  { to: "/legal/refunds", label: "Refund / Cancellation" },
  { to: "/legal/licensing", label: "Licensing / Usage Rights" },
];

export default function Footer() {
  const [email, setEmail] = useState("hello@arsenalartists.co");
  useEffect(() => {
    api.get("/content").then((r) => {
      if (r.data?.contact_email) setEmail(r.data.contact_email);
    }).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#070709]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="flex items-center gap-3">
            <img src="/arsenal-artists-logo.png" alt="Arsenal Artists emblem" className="h-12 w-12 object-contain" />
            <span className="font-display font-extrabold tracking-[0.18em] text-white">
              ARSENAL <span className="text-arsenal">ARTISTS</span>
            </span>
          </Link>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
            A digital creative studio for creators, communities and businesses. Part of the Arsenal family.
          </p>
          <a href={`mailto:${email}`} data-testid="footer-email" className="mt-4 inline-block text-sm text-steel hover:text-arsenal transition-colors">
            {email}
          </a>
        </div>
        <nav aria-label="Services">
          <h4 className="font-mono text-[11px] tracking-[0.25em] text-arsenal mb-4">SERVICES</h4>
          <ul className="space-y-2.5">
            {SERVICE_LINKS.map((l) => (
              <li key={l.label}>
                <Link to={l.to} data-testid={`footer-service-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-slate-400 hover:text-white transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Studio">
          <h4 className="font-mono text-[11px] tracking-[0.25em] text-arsenal mb-4">STUDIO</h4>
          <ul className="space-y-2.5">
            {STUDIO_LINKS.map((l) => (
              <li key={l.label}>
                <Link to={l.to} data-testid={`footer-studio-${l.label.toLowerCase().replace(/ /g, "-")}`} className="text-sm text-slate-400 hover:text-white transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Legal">
          <h4 className="font-mono text-[11px] tracking-[0.25em] text-arsenal mb-4">LEGAL</h4>
          <ul className="space-y-2.5">
            {LEGAL_LINKS.map((l) => (
              <li key={l.label}>
                <Link to={l.to} data-testid={`footer-legal-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-slate-400 hover:text-white transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Arsenal Artists. All rights reserved.</p>
          <p className="font-mono text-[11px] tracking-[0.2em] text-slate-600">ARSENALARTISTS.CO</p>
        </div>
      </div>
    </footer>
  );
}
